import { OverlayService } from '@sircon/sircon-ui-framework';
import { AuthenticationService } from 'src/services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Controller containing logic for the app's unexpected error page, used both while authenticated or unauthenticated.
 */
@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.less']
})
export class ErrorComponent implements OnInit {
    authenticated: any;
    submitLabel: string;

    constructor(
        private router: Router,
        private overlayService: OverlayService,
        private authenticationService: AuthenticationService
    ) {
    }

    ngOnInit() {
        this.authenticated = this.authenticationService.isAuthenticated();
        this.submitLabel = this.authenticated ? 'Back to Dashboard' : 'Sign In';

        // Close the overlay just in case the page that directed the user here was processing
        this.overlayService.close();

        if (!this.authenticated) {
            this.submitLabel = 'Sign In';
        }
    }

    submit() {
        const targetState = this.authenticated ? 'dashboard' : 'login';
        // Navigate without any query params to clear error params
        // Use navigateByUrl to ensure we get a clean URL
        this.router.navigateByUrl('/' + targetState);
    }
}
